import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getUsersList = async (param) => {
  const baseUrl = `${API_CONSTANTS.GET_USER_NEW}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};
export const adduser = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.post(
    `${API_CONSTANTS.GET_USER}/add`,
    payload
  );
  return response;
};
export const updateuser = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.GET_USER}/update?id=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.put(url, payload);
  return response;
};
export const getuserById = async (id) => {
  let url = `${API_CONSTANTS.GET_USER}/detail?userManagementDetailId=${id}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const deleteuser = async (id) => {
  let url = `${API_CONSTANTS.GET_USER}/delete?userManagementDetailId=${id}`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.del(url, payload);
  return responseObj;
};

// ---------------------------------------------------Permission APIS-------------------------------------------------------------

export const getRoleList = async (id) => {
  let url = `${API_CONSTANTS.GET_USER}/role-list`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const getModulesList = async (id) => {
  let url = `${API_CONSTANTS.GET_USER}/module-list`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const getPermissionList = async (id) => {
  let url = `${API_CONSTANTS.GET_USER}/permission?id=${id}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const getParentMalls = async (userId) => {
  let url = `${API_CONSTANTS.GET_USER}/parent-mall-list?userId=${userId}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};
export const saveParentMalls = async (userId, parentMalls) => {
  let url = `${API_CONSTANTS.GET_USER}/parent-mall-save`;
  let payload = { data: { userId, parentMalls } };
  let response = await dataAccess.post(url, payload);
  return response;
};
export const addPermission = async (incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.GET_USER}/permission-add`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.post(url, payload);
  return response;
};
export const updatePermission = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.GET_USER}/permission-update?permissionId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.put(url, payload);
  return response;
};
export const deletePermission = async (id) => {
  let url = `${API_CONSTANTS.user}/delete-permission`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.del(url, payload);
  return responseObj;
};
export const getuserPermissionofModulesbyMallId = async (id) => {
  let url = `${API_CONSTANTS.user}/mall-permission`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.get(url, payload);
  return responseObj;
};
